import { all, getContext, call } from 'redux-saga/effects';
import { ILocalinaWidgetApi } from '../interfaces';
import reservationSaga from './reservation/reservation-saga';
import restaurantSaga from './restaurant/restaurant-saga';
import cancelReservationSaga from './cancelReservation/cancelReservation-saga';

export default function* rootSaga() {
    const widgetApi: ILocalinaWidgetApi = yield getContext('widgetApi');
    const effects = [
        call(reservationSaga, widgetApi),
        call(restaurantSaga, widgetApi),
        call(cancelReservationSaga, widgetApi),
    ];
    yield all(effects);
}
